interface CheckBoxNewIconProps {
  className?: string;
  checked?: boolean;
  size?: number;
  color?: string;
}

export const CircleCheckBoxIcon = ({ className, checked, size = 16, color = '#915FFF' }: CheckBoxNewIconProps) =>
  checked ? (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill={color} />
      <path
        d="M4.32306 7.91925L7.08078 10.677L11.677 6.08077"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="7.2" stroke="#D0D7DE" strokeWidth="0.96" />
    </svg>
  );
